import { Component, OnInit } from '@angular/core';
import { CacheFilterService } from '../../../services/cache/cache-filter.service';
import { PhysicianFilter } from '../../../model/physician-Filter';
import { FilterCompleteService } from '../../../filter-complete/filter-complete';
import { PatientCrmAssignmentDialogComponent, PatientCrmAssignmentDialogResponse } from '../patient-crm-assignment-dialog/patient-crm-assignment-dialog.component';
import { MatDialog } from '@angular/material';
import { PatientAssignationService } from '../../../services/patient-assignation.service';
import { ActivatedRoute } from '@angular/router';
import { PatientAssignation, PatientAssignationPhysician } from '../../../model/patient/patient-assignation';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { PatientCrmCoordinatorDialogComponent } from '../patient-crm-coordinator-dialog/patient-crm-coordinator-dialog.component';
import { PatientCrmAssigmentBudgetTimeDialogComponent, PatientCrmAssigmentBudgetTimeResponse } from '../patient-crm-assigment-budget-time-dialog/patient-crm-assigment-budget-time-dialog.component';

@Component({
  selector: 'app-patient-crm-assignment',
  templateUrl: './patient-crm-assignment.component.html',
  styleUrls: ['./patient-crm-assignment.component.css']
})
export class PatientCrmAssignmentComponent implements OnInit {

  coordinators: PhysicianFilter[] = [];
  physicians: PatientAssignationPhysician[] = [];
  patientId: number;
  budgetTime?: number;

  constructor( private dialog: MatDialog,
               private route: ActivatedRoute,
               private notificationToastService: NotificationToastService,
               private patientAssignationService: PatientAssignationService ) {
  }

  async ngOnInit() {

    this.patientId = this.route.snapshot.params.Id;
    const info = await this.patientAssignationService
      .getPatientAssignation( this.patientId );

    if ( info != null ) {
      this.budgetTime = info.BudgetTime;
      this.coordinators = info.Coordinators;
      this.physicians = info.Physicians;
    }

  }

  addBudgetTime() : void {

    const dialogRef = this.dialog.open(PatientCrmAssigmentBudgetTimeDialogComponent, {
      width: '50%',
      data: {
        patientId: this.patientId,
        budgetTime: this.budgetTime
      }
    });

    dialogRef.afterClosed().subscribe((response: PatientCrmAssigmentBudgetTimeResponse) => {
      if (response) {
        this.budgetTime = response.budgetTime;
      }
    });

  }

  addCoordinator(): void {

    const dialogRef = this.dialog.open(PatientCrmCoordinatorDialogComponent, {
      width: '50%',
      data: this.patientId
    });

    dialogRef.afterClosed().subscribe((response: PhysicianFilter) => {
      if (response) {
        this.coordinators.push(response);
      }
    });

  }

  async removeCoordinator(physician: PhysicianFilter) {
    try {
      physician.Loading = true;
      await this.patientAssignationService
            .unassignCoordinator(
                this.patientId,
                physician.Id);
      const index = this.coordinators.findIndex(p => p === physician);
      this.coordinators.splice(index, 1);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Asignación de coordinador');
    } finally {
      physician.Loading = false;
    }

  }


  addAt(): void {

    const dialogRef = this.dialog.open(PatientCrmAssignmentDialogComponent, {
      width: '50%',
      data: {
        PatientId: this.patientId,
        PhysicianIds: this.physicians.map(p => p.Physician.Id)
      }
    });

    dialogRef.afterClosed().subscribe((response: PatientCrmAssignmentDialogResponse) => {
      if (response) {
        this.physicians.push(
          {
            PracticeRegion: response.PracticeRegion,
            Physician: response.Physician,
            Loading: false
          }
        );
      }
    });

  }

  async removeAt(physician: PatientAssignationPhysician) {
    try {
      physician.Loading = true;
      await this.patientAssignationService
            .unassignTherapeuticCompanion(
                this.patientId,
                physician.Physician.Id);
      const index = this.physicians.findIndex(p => p === physician);
      this.physicians.splice(index, 1);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Asignación de profesional');
    } finally {
      physician.Loading = false;
    }
  }

}
